goog.provide("shadow.js.shim.module$src$svg$editor$formatting$list_svg$default");
shadow.js.shim.module$src$svg$editor$formatting$list_svg$default = shadow.js.shim.module$src$svg$editor$formatting$list_svg.default;
